var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas",class:_vm.profileInfo('image'),style:('color:' + _vm.profileInfo('color'))})}
var staticRenderFns = []

export { render, staticRenderFns }